import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FormModule } from 'lib/ui/form/form.module.js';
import { CoreModule } from 'src/app/core/core.module.js';
import { NutritionModule } from '../../../../lib/ui/nutrition/nutrition.module.js';
import { FoodsModule } from '../foods/foods.module.js';
import { DietFormComponent } from './diet-form.component.js';
import { ListDietsComponent } from './list-diets.component.js';
import { ViewOrEditDietComponent } from './view-or-edit-diet.component.js';

@NgModule({
	declarations: [ViewOrEditDietComponent, ListDietsComponent, DietFormComponent],
	exports: [ViewOrEditDietComponent, ListDietsComponent, DietFormComponent],
	imports: [CoreModule, FormModule, FormsModule, FoodsModule, NutritionModule]
})
export class DietsModule {}
